import { useState } from 'react';
import { Container } from './styles';
import Title from '../common/Title';
import Form from './Form';
import ProgramList from './ProgramList';

const ScoringPrograms = () => {
    const [loadingList, setLoadingList] = useState(true);
    const initialValues = {
        name: '',
        description: '',
        number_score: '',
        days: '',
        is_active: 1,
    };
    return (
        <Container>
            <Title>Programas de recompensas - puntos en score panel</Title>
            <p>Creación de programas tiene como objetivo asignar (puntos) a nuestro inventario directo. </p>
            <Form type='Crear' initialValues={initialValues} setLoadingList={setLoadingList} />
            <ProgramList loadingList={loadingList} setLoadingList={setLoadingList} />
        </Container>
    );
};

export default ScoringPrograms;
